module.exports = {
  version: 107, // 版本号
  versionname: "1.0.7", // 版本号
  channel: "h5",
  ...require('./cdConfig.js')
};
